import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { NavContext } from "../../../state/NavContext";
import {
  Row,
  Col,
  Image,
  Divider,
  Skeleton,
  Typography,
  Space,
  notification,
} from "antd";
import Title from "antd/lib/typography/Title";

const { Text } = Typography;

const GameDetail = () => {
  const { id } = useParams();
  const [game, setGame] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("games");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  useEffect(() => {
    if (!isLoaded) {
      axios
        .get(`https://backendexample.sanbersy.com/api/data-game/${id}`)
        .then((res) => {
          setGame(res.data);
          setIsLoaded(true);
        })
        .catch((err) => {
          notification.error({
            message: "Error Loading Data",
            description: err.response.data.message,
            placement: "topRight",
          });
          console.log(err.response.data.message);
          setIsLoaded(true);
        });
    }
  }, []);

  useEffect(() => {
    setActiveIndex("games");
  }, [setActiveIndex]);

  return (
    <Row className="game-detail">
      <Col span={6}>
        <Image
          width="100%"
          height={400}
          style={{ objectFit: "cover" }}
          src={
            game.image_url
              ? game.image_url
              : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAA1BMVEXR0dFCxnTBAAAASElEQVR4nO3BgQAAAADDoPlTX+AIVQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwDcaiAAFXD1ujAAAAAElFTkSuQmCC"
          }
          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAA1BMVEXR0dFCxnTBAAAASElEQVR4nO3BgQAAAADDoPlTX+AIVQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwDcaiAAFXD1ujAAAAAElFTkSuQmCC"
        />
      </Col>
      <Col span={18}>
        <div className="detail">
          {isLoaded ? (
            <Title level={2}>{game.name}</Title>
          ) : (
            <Skeleton loading={true} paragraph={false} title={true} />
          )}
          <Divider />
          {isLoaded ? (
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row>
                <Col span="6">
                  <Text>Year:</Text>
                </Col>
                <Col span="18">
                  <Text type="secondary">{game.release}</Text>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Text>Genre:</Text>
                </Col>
                <Col span="18">
                  <Text type="secondary">{game.genre}</Text>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Text>Platform:</Text>
                </Col>
                <Col span="18">
                  <Text type="secondary">{game.platform}</Text>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Text>Single Player:</Text>
                </Col>
                <Col span="18">
                  <Text type="secondary">
                    {game.singlePlayer > 0 ? "Available" : "Not Available"}
                  </Text>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Text>Multi Player:</Text>
                </Col>
                <Col span="18">
                  <Text type="secondary">
                    {game.multiplayer > 0 ? "Available" : "Not Available"}
                  </Text>
                </Col>
              </Row>
            </Space>
          ) : (
            <Skeleton active paragraph={true} loading={true} />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default GameDetail;
